import React, { useContext, useEffect, useRef, useState } from 'react';
import { ApiContext } from '@api/api';
import { AutoComplete } from 'primereact/autocomplete';

interface ComponentProps {
  department: string;
  onChange: (department: string) => void;
  style?: any;
  disabled?: boolean;
}

const InputDepartmentPlain: React.FC<ComponentProps> = ({ style, onChange, department, disabled = false }) => {
  const { cuLovDepartments } = useContext(ApiContext);
  const [allDepartments, setAllDepartments] = useState<string[]>([])
  const [suggestions, setSuggestions] = useState<string[]>([]);


  useEffect(() => {
    cuLovDepartments('', d => {
      setAllDepartments(d);
    });
  }, [cuLovDepartments]);

  const inputRef = useRef(undefined);

  return (
      <AutoComplete
        disabled={disabled}
        suggestions={suggestions}
        value={department || ''}
        inputRef={inputRef}
        onChange={e => onChange(e.value)}
        onSelect={e => onChange(e.value)}
        completeMethod={e => {
          const query = e.query.toLowerCase();
          setSuggestions(
            allDepartments.filter(t => t.toLowerCase().includes(query))
          );
        }}
      />
  );
};

export default InputDepartmentPlain;
